/**
 * @param AjaxForm Base widget for extending
 * @returns ProductStorePickupForm widget
 */
export default function (AjaxForm: ReturnType<typeof import('widgets/forms/AjaxForm').default>) {
    /**
     * @category widgets
     * @subcategory forms
     * @class ProductStorePickupForm
     * @augments AjaxForm
     * @classdesc Represents ProductStorePickupForm component with next features:
     * 1. Shows a list of stores with the available selected product
     */
    class ProductStorePickupForm extends AjaxForm {
        /**
         * @description Shows list of stores with the available selected product
         * @param data Server JSON response once form submitted
         */
        onSubmitted(data) {
            if (data.success) {
                this.render('template', {
                    hasAnyStores: data.currentCountryStores.stores.length > 0 || Object.keys(data.worldwideStores).length > 0,
                    currentCountry: data.currentCountryStores,
                    hasCurrentCountryStores: data.currentCountryStores.stores.length > 0,
                    worldwideStores: Object.values(data.worldwideStores),
                    hasWorldwideStores: Object.keys(data.worldwideStores).length > 0
                }, this.ref('container'));
            }
        }
    }

    return ProductStorePickupForm;
}
